import {
    I18nConfiguration,
    PartnerProductConfiguration,
    defaultPartnerProductConfiguration,
} from '@soluto-private/mx-types';
import { Key, storage } from '@soluto-private/mx-context';
import { Provider, createProvider } from '@soluto-private/mx-config';

const OneServiceApiProvider = createProvider<Provider.OneServiceApi>(
    Provider.OneServiceApi
);

export const getI18nConfiguration = async (): Promise<I18nConfiguration> => {
    const partner = storage.get(Key.Client);
    if (!partner) {
        return defaultPartnerProductConfiguration.i18n;
    }

    const productType = storage.get(Key.ProductType);

    const partnerProductConfiguration: PartnerProductConfiguration | null =
        await OneServiceApiProvider.getPartnerProductConfiguration(
            partner,
            productType
        );

    return (
        partnerProductConfiguration?.i18n ??
        defaultPartnerProductConfiguration.i18n
    );
};
